export default __webpack_public_path__ + "static/media/nl.299ae456.svg";